export default __webpack_public_path__ + "tiktok-hrz-v1.svg";